var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top-error" } },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.contests.config
        ? _c(
            "form",
            { attrs: { id: "edit-user-form", autocomplete: "qwerqrt" } },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 col-lg-12 mb-0" },
                [
                  _vm._l(_vm.products, function(elem, num) {
                    return _c(
                      "div",
                      {
                        key: num,
                        staticClass: "row",
                        on: {
                          click: function($event) {
                            return _vm.priceMod(num)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "group ml-0 mr-0" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "lable-style",
                                  attrs: { for: "product" }
                                },
                                [_vm._v("Prodotto")]
                              ),
                              _vm._v(" "),
                              _c("v-select", {
                                key: elem.product,
                                attrs: {
                                  options: _vm.products_contest,
                                  clearable: false
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectChange(_vm.products)
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "search",
                                      fn: function(ref) {
                                        var attributes = ref.attributes
                                        var events = ref.events
                                        return [
                                          _c(
                                            "input",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "vs__search",
                                                  attrs: {
                                                    required: !elem.product
                                                  }
                                                },
                                                "input",
                                                attributes,
                                                false
                                              ),
                                              events
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: elem.product,
                                  callback: function($$v) {
                                    _vm.$set(elem, "product", $$v)
                                  },
                                  expression: "elem.product"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _vm.errProd
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-1" },
                                    [
                                      _vm._v(
                                        "\n                Devi inserire almeno un prodotto tra quelli in elenco\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "group ml-0 mr-0" }, [
                            _c(
                              "label",
                              {
                                staticClass: "lable-style",
                                attrs: { for: elem.indexCount }
                              },
                              [_vm._v("Quantità")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: elem.quantity,
                                  expression: "elem.quantity"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    is_not: "0",
                                    min_value: 1,
                                    max_value:
                                      _vm.contests.config.PRODOTTI_MASSIMO,
                                    max: 2
                                  },
                                  expression:
                                    "{\n                  required: true,\n                  is_not: '0',\n                  min_value: 1,\n                  max_value: contests.config.PRODOTTI_MASSIMO,\n                  max: 2,\n                }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(elem.indexCount),
                                valid: !!elem.quantity,
                                dis: !_vm.contests.config.QNT_MODIFICABILE
                              },
                              attrs: {
                                type: "number",
                                disabled: !_vm.contests.config.QNT_MODIFICABILE,
                                id: elem.indexCount,
                                name: elem.indexCount,
                                "data-vv-as": "Quantità"
                              },
                              domProps: { value: elem.quantity },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    elem,
                                    "quantity",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _vm.errors.has(elem.indexCount)
                              ? _c(
                                  "div",
                                  { staticClass: "invalid-feedback-1" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.errors.first(elem.indexCount)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _vm.contests.config.DESTINAZIONE_SCONTO != "PUNTI"
                            ? _c("div", { staticClass: "group ml-0 mr-0" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "lable-style",
                                    attrs: { for: elem.indexCount }
                                  },
                                  [_vm._v("Importo unitario")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: elem.price,
                                      expression: "elem.price"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        is_not: "0",
                                        decimal: 2
                                      },
                                      expression:
                                        "{ required: true, is_not: '0', decimal: 2 }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      elem.indexCount + "p"
                                    ),
                                    valid: !!elem.price,
                                    dis: !_vm.priceMod1
                                  },
                                  attrs: {
                                    type: "text",
                                    disabled: !_vm.priceMod1,
                                    id: elem.indexCount + "p",
                                    name: elem.indexCount + "p",
                                    "data-vv-as": "importo unitario"
                                  },
                                  domProps: { value: elem.price },
                                  on: {
                                    focus: function($event) {
                                      return _vm.activateMod(elem.price)
                                    },
                                    blur: function($event) {
                                      return _vm.deactivateMod(elem.price)
                                    },
                                    keyup: function($event) {
                                      elem.price = elem.price.replace(",", ".")
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        elem,
                                        "price",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.errors.has(elem.indexCount + "p")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback-1" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                elem.indexCount + "p"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contests.config.DESTINAZIONE_SCONTO == "PUNTI"
                            ? _c("div", { staticClass: "group ml-0 mr-0" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "lable-style",
                                    attrs: { for: elem.indexCount }
                                  },
                                  [_vm._v("Punteggio unitario")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: elem.points,
                                      expression: "elem.points"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        is_not: "0",
                                        decimal: 2
                                      },
                                      expression:
                                        "{ required: true, is_not: '0', decimal: 2 }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      elem.indexCount + "p"
                                    ),
                                    valid: !!elem.points,
                                    dis: !_vm.priceMod1
                                  },
                                  attrs: {
                                    type: "text",
                                    disabled: !_vm.priceMod1,
                                    id: elem.indexCount + "p",
                                    name: elem.indexCount + "p",
                                    "data-vv-as": "importo unitario"
                                  },
                                  domProps: { value: elem.points },
                                  on: {
                                    focus: function($event) {
                                      return _vm.activateMod(elem.points)
                                    },
                                    blur: function($event) {
                                      return _vm.deactivateMod(elem.points)
                                    },
                                    keyup: function($event) {
                                      elem.points = elem.points.replace(
                                        ",",
                                        "."
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        elem,
                                        "points",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.errors.has(elem.indexCount + "p")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback-1" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                elem.indexCount + "p"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          num
                            ? _c(
                                "span",
                                {
                                  staticClass: "removeProduct pointer",
                                  class: elem.index
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticStyle: {
                                      background: "white",
                                      "margin-right": "11px",
                                      "margin-top": "25px"
                                    },
                                    attrs: { icon: "trash-alt", size: "lg" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeProduct(num)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row justify-content-center pb-5" },
                    [
                      _vm.contests.config
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-md-6 col-lg-6 mb-3 text-left vcenter mt-md-0 mt-3"
                            },
                            [
                              !_vm.numMaxQnt_prod &&
                              !_vm.numMax_prod &&
                              !_vm.numMaxAttempts_prod
                                ? _c("img", {
                                    staticClass:
                                      "addProduct imageIcons pointer",
                                    on: { click: _vm.addProduct }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.numMaxQnt_prod &&
                              !_vm.numMax_prod &&
                              !_vm.maxSelOk &&
                              !_vm.numMaxAttempts_prod
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "fixPointer white",
                                      on: { click: _vm.addProduct }
                                    },
                                    [
                                      _c("b", [_vm._v("+")]),
                                      _vm._v(" Aggiungi prodotto")
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showProdError &&
                              _vm.contests.config.PRODOTTI_MINIMO
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare l'inserimento é necessario aver acquistato\n              in un unico atto d’acquisto almeno\n              " +
                                        _vm._s(
                                          _vm.contests.config.PRODOTTI_MINIMO
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.contests.config.PRODOTTI_MINIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showProdError &&
                              _vm.contests.config.PREZZO_MINIMO > 0
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare l'inserimento é necessario aver acquistato\n              in un unico atto d’acquisto almeno\n              " +
                                        _vm._s(
                                          _vm.contests.config.PREZZO_MINIMO
                                        ) +
                                        " € di\n              "
                                    ),
                                    _vm.contests.config.PREZZO_MINIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.numMaxQnt_prod
                                ? _c("small", { staticClass: "red Bold h5" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per poter registrare la richiesta per questa promozione\n              puoi inserire massimo " +
                                        _vm._s(
                                          _vm.contests.config.PRODOTTI_MASSIMO
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.contests.config.PRODOTTI_MASSIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.numMax_prod && !_vm.numMaxQnt_prod
                                ? _c("small", { staticClass: "black" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per poter registrare la richiesta per questa promozione\n              puoi inserire massimo " +
                                        _vm._s(
                                          _vm.contests.config.PRODOTTI_MASSIMO
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.contests.config.PRODOTTI_MASSIMO > 1
                                      ? _c("a", [_vm._v("prodotti")])
                                      : _c("a", [_vm._v("prodotto")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.numMaxAttempts_prod
                                ? _c("small", { staticClass: "red Bold" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per questa promozione hai diritto a massimo\n              " +
                                        _vm._s(_vm.maxRegistration) +
                                        " buoni, attualmente hai usufruito di\n              " +
                                        _vm._s(_vm.my_registration_in_promo) +
                                        " buoni, ne hai a disposizione ancora\n              " +
                                        _vm._s(
                                          _vm.maxRegistration -
                                            _vm.my_registration_in_promo
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.maxSelOk
                        ? _c("div", {
                            staticClass:
                              "col-md-6 col-lg-6 mb-3 text-left vcenter mt-md-0 mt-3"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.contests.config
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-md-6 col-lg-6 mb-3 text-right pt-2"
                            },
                            [
                              _vm.totPrice &&
                              _vm.contests.config.DESTINAZIONE_SCONTO != "PUNTI"
                                ? _c(
                                    "h5",
                                    {
                                      staticClass: "Bold",
                                      class: {
                                        "invalid-feedback-1": _vm.priceError
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Totale prodotti: " +
                                          _vm._s(_vm.totPrice) +
                                          "€\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.totPrice &&
                              _vm.contests.config.DESTINAZIONE_SCONTO == "PUNTI"
                                ? _c(
                                    "h5",
                                    {
                                      staticClass: "Bold",
                                      class: {
                                        "invalid-feedback-1": _vm.priceError
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Punteggio richiesto: " +
                                          _vm._s(_vm.totPrice) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.minPrice_products &&
                              _vm.contests.config.PREZZO_MINIMO
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare la richiesta di rimborso é necessario che la\n              somma dei prodotti sia almeno " +
                                        _vm._s(
                                          _vm.contests.config.PREZZO_MINIMO
                                        ) +
                                        "€\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.maxPrice_products &&
                              _vm.contests.config.PREZZO_MASSIMO
                                ? _c("small", { staticClass: "red" }, [
                                    _c("br"),
                                    _vm._v(
                                      "!Per completare la richiesta di rimborso é necessario che la\n              somma dei prodotti non superi la soglia massima di\n              " +
                                        _vm._s(
                                          _vm.contests.config.PREZZO_MASSIMO
                                        ) +
                                        "€\n            "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6 center" }, [
                        _vm.uploadFrontPercentage == 0
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary-1 uppercase pl-3 mb-0",
                                style:
                                  "background: " +
                                  _vm.contests.config.COLORE_MEDIO_SCURO +
                                  "!important",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.play()
                                  }
                                }
                              },
                              [
                                _c("a", [
                                  _vm._v("Registra richiesta di rimborso")
                                ])
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.mobileUpl
                        ? _c(
                            "div",
                            { staticClass: "col-md-6 center mt-2 pt-1 center" },
                            [
                              _vm.uploadFrontPercentage == 0
                                ? _c(
                                    "b",
                                    {
                                      staticClass:
                                        "hover underline color uppercase pl-3 mb-0",
                                      on: { click: _vm.logout }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Termina ed esegui il logout\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center mb-1 pt-2 pt-5" }, [
      _c("h5", { staticClass: "uppercase" }, [
        _vm._v(
          "\n          Inserisci i/il prodotti/o presenti/e nello scontrino :\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eda55834", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eda55834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/play/step_2_prodotti.vue
// module id = null
// module chunks = 